import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ComposeProviders = ({
  providers,
  children
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: providers.reduceRight((childrenWithContexts, [Context, contextValue]) => {
      const ContextProvider = 'Provider' in Context ? Context.Provider : Context;
      return /*#__PURE__*/_jsx(ContextProvider, {
        value: contextValue,
        children: childrenWithContexts
      });
    }, children)
  });
};
export default ComposeProviders;